import React, { ButtonHTMLAttributes } from 'react';

import styled from 'styled-components';
import { IconType } from 'react-icons';

import CustomTooltip from 'components/CustomTooltip';

const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Button = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px !important;
  border: none !important;
  background-color: transparent !important;
  font-size: 20px;

  &:disabled {
    opacity: 0.4;
  }
`;

interface FlowHeaderButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  id: string;
  tooltip?: string;
  Icon: IconType;
}

const FlowHeaderButton = React.forwardRef(
  ({ id, tooltip, Icon, ...rest }: FlowHeaderButtonProps, ref: React.ForwardedRef<HTMLButtonElement>) => {
    const className = `flow-tabbar-${id}`;
    if (tooltip) {
      return (
        <Container>
          <Button className={className} ref={ref} {...rest}>
            <Icon />
          </Button>
          <CustomTooltip anchorSelect={`.${className}`} hasDelay>
            {tooltip}
          </CustomTooltip>
        </Container>
      );
    }
    return (
      <Button ref={ref} {...rest}>
        <Icon />
      </Button>
    );
  }
);

export default FlowHeaderButton;
